import { Timespan } from '../../../chart-settings/model';
import { ThroughputMonitoredServiceQuery } from '../../config';
import { ThroughputMonitoredServiceApiModel } from '../../model';
import { AxiosInstanceProvider } from '../../../../core/hooks';

export interface GetThroughputMonitoredServicesPayloadModel {
  customerId: number;
  timespan: Timespan;
}

type GetThroughputMonitoredServicesHttpGetResponseModel = ThroughputMonitoredServiceApiModel[];

export const getThroughputMonitoredServices = async (
  provideAxios: AxiosInstanceProvider,
  { customerId, timespan }: GetThroughputMonitoredServicesPayloadModel
): Promise<GetThroughputMonitoredServicesHttpGetResponseModel> => {
  const apiUrl = ThroughputMonitoredServiceQuery['GetThroughputMonitoredServices'].url
    .replace('{customerId}', customerId.toString(10));
  const params = { timespan };
  const response = await provideAxios()
    .get<GetThroughputMonitoredServicesHttpGetResponseModel>(apiUrl, { params });
  return response.data;
};